import ErrorBoundary from 'components/ErrorBoundary'
import React, { useState } from 'react'
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import Arrow from "assets/icon/Left-Chevron.svg";
import Location from '../Location';
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import General from '../GeneralTab';


const ConveredentityDetails = (props) => {
    const {
        Cedata,setCEflag,orgId,rowData,setConfigFlag,
        configflag,setCEDId,
        CEDid,configlevel,setCElevelflag,
        CElevelflag,setACCflag,viewConfig,
        setviewConfig,setLoading,
        loading,
    } = props;
        console.log(Cedata,"cedata")
          const [key, setkey] = useState("general");
            const [reset, setReset] = useState(false);
          
          const onKeyChange = (k) => {
            setkey(k);
         setReset(!reset);
          };
    const handelCEhistory = () => {
        setCEflag(false);
        setConfigFlag(false)
        setviewConfig(false)
        setACCflag(false);

        if(configlevel==true){
setCElevelflag(false)
        }
      };
   
  return (
    <div>       
              <Container fluid className="my-3 bin_info p-0">
        <Card className='border-0 shadow-top'>
    <CardBody className='section-devider-border'>
        <ErrorBoundary>
            <Row>
            <div className="d-flex align-items-center">
            <h4 className='f-16 text-primary font-weight-700'style={{ cursor: "pointer" }}
                //   onClick={handelCEhistory}
                  >
                    {/* <span
                    style={{
                      paddingRight: "5px",
                      position: "relative",
                      top: "-1px",
                      cursor: "pointer",
                    }}
                  >
                    <img style={{ width: "8px" }} src={Arrow} />
                  </span>{" "} */}
                  Covered Entity Details
            </h4>
            </div>
          
                <Col md="4">
                    <p className="m-0 f-14 mt-3">Covered Entity Name :</p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{Cedata.coveredEntityName}</p>
                </Col>
                <Col md="4">
                    <p className="m-0 f-14 mt-3">Covered Entity Type :</p>
                    <p className="m-0 f-14 font-weight-500 mt-1">{Cedata.coveredEntityType}</p>
                </Col>
                <Col md="4">
                    <p className="m-0 f-14 mt-3">OPA Code :</p>
                    {/* <p className="m-0 f-14 font-weight-500 mt-1">{Cedata.opaCode}</p> */}
                    <p className="m-0 f-14 font-weight-500 mt-1">{Cedata.opaCode}</p>

                </Col>
                
             


            </Row>
          
         
            

        </ErrorBoundary>

    </CardBody>
  
   

      </Card>

{/* <Card className='border-0 shadow-top mt-3'>
          <CardBody>
          <Tabs
          id="controlled-tab-example"
          activeKey={key}
          // onSelect={(k) => setkey(k)}
          onSelect={(k) => onKeyChange(k)}
          className="mb-3"
        >
         
          <Tab eventKey="general" title="General">
            <General
            //   rowData={rowData}
            //   SelectedAccumulatorOrder={rowData.accumulatorID}
            />
          </Tab>

          <Tab eventKey="locationTab" title="Location">
            <Location
              orgId={orgId}
              key={key}
              rowData={rowData}
              SelectedAccumulator={rowData?.accumulatorID}
            />
          </Tab>
         
        </Tabs>
          </CardBody>
        </Card> */}
        </Container>
</div>
  )
}

export default ConveredentityDetails